import React from 'react';
import styled from 'styled-components';
import { Input } from 'antd';
import PropTypes from 'prop-types';

const StyledInput = styled(Input)`
  &.ant-input, &.ant-input-password {
    background: rgba(255, 255, 255, 0.4) !important;
    backdrop-filter: blur(4px);
    border: 1px solid rgba(0, 0, 0, 0.08) !important;
    border-radius: var(--radius-sm) !important;
    padding: 10px 16px;
    font-family: 'Outfit', sans-serif;
    transition: var(--transition-smooth);

    &:hover {
      border-color: var(--waya-red-hover) !important;
      background: rgba(255, 255, 255, 0.6) !important;
    }

    &:focus, &.ant-input-focused, &.ant-input-affix-wrapper-focused {
      background: white !important;
      border-color: var(--waya-red) !important;
      box-shadow: 0 0 0 4px var(--waya-red-glass) !important;
    }
  }

  &.ant-input-affix-wrapper {
    background: rgba(255, 255, 255, 0.4);
    backdrop-filter: blur(4px);
    border: 1px solid rgba(0, 0, 0, 0.08);
    border-radius: var(--radius-sm);
    padding: 10px 16px;

    .ant-input {
      background: transparent !important;
      border: none !important;
      padding: 0 !important;
      box-shadow: none !important;
    }
  }
`;

const StyledTextArea = styled(Input.TextArea)`
  &.ant-input {
    background: rgba(255, 255, 255, 0.4) !important;
    backdrop-filter: blur(4px);
    border: 1px solid rgba(0, 0, 0, 0.08) !important;
    border-radius: var(--radius-sm) !important;
    padding: 10px 16px;
    font-family: 'Outfit', sans-serif;
    transition: var(--transition-smooth);

    &:hover {
      border-color: var(--waya-red-hover) !important;
      background: rgba(255, 255, 255, 0.6) !important;
    }

    &:focus, &.ant-input-focused {
      background: white !important;
      border-color: var(--waya-red) !important;
      box-shadow: 0 0 0 4px var(--waya-red-glass) !important;
    }
  }
`;

const PremiumInput = (props) => {
  return <StyledInput {...props} />;
};

PremiumInput.Password = (props) => {
  return <StyledInput.Password {...props} />;
};

PremiumInput.TextArea = (props) => {
  return <StyledTextArea {...props} />;
};

PremiumInput.propTypes = {
  // Accepts all antd Input props
};

export default PremiumInput;
